<div class="row" id="main-content">
  <div class="col-sm-12 h-100">
    <div class="row">
      <div class="col-sm-9 menu">
        <mat-form-field appearance="fill" style="width: 22%">
          <mat-label>Type</mat-label>
          <mat-select [(value)]="selectedAlertTypeId" (selectionChange)="typeChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (type of types; track type) {
              <mat-option [value]="type.id">{{type.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 15%">
          <mat-label>Customer</mat-label>
          <mat-select [(value)]="selectedCustomerId" (selectionChange)="customerChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (customer of customers; track customer) {
              <mat-option [value]="customer.id">{{customer.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 22%">
          <mat-label>Status</mat-label>
          <mat-select [(value)]="selectedStatusId" (selectionChange)="statusChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (status of statuses; track status) {
              <mat-option [value]="status.id">{{status.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" style="width: 22%">
          <mat-label>Vehicle</mat-label>
          <mat-select [(value)]="selectedBlackboxId" (selectionChange)="blackboxChange($event.value)" (openedChange)="dropdownChanged($event)" multiple>
            @for (blackbox of blackboxes; track blackbox) {
              <mat-option [value]="blackbox.id">{{blackbox.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>

      </div>
      <div class="col-sm-3 justify-content-end">
        @if (alertsSelected()) {
          <button class="btn btn-primary" (click)="acknowledge(null)">Acknowledge Selected</button>
          }&nbsp;
          @if (alertsSelected()) {
            <button class="btn btn-primary" (click)="close(null)">Close Selected</button>
            }&nbsp;
            <button class="btn btn-primary float-right" (click)="refresh()"><mat-icon>refresh</mat-icon></button>
          </div>
          <div class="col-sm-12 maincontentholder">
            <app-paging [paging]="paging" [pageChangeFunction]="changePage" [parentComponent]="this" showPageLabel="true"></app-paging>
            <table class='table table-striped' aria-labelledby="tableLabel">
              <thead>
                <tr>
                  <th class="vehicle">
                    <input type="checkbox" name="all" [checked]="isAllChecked()" (change)="checkAll($event)"/>
                  </th>
                  <th class="priority" title="Click to sort by priority"><a (click)="sortTable('priorityId')">&nbsp;</a> <span [innerHTML]="getSortIcon('priorityId')"></span></th>
                  <th class="vehicle"><a (click)="sortTable('AlertId')">Type</a> <span [innerHTML]="getSortIcon('alertDescription')"></span></th>
                  <th class="location"><a (click)="sortTable('Created')">Date</a> <span [innerHTML]="getSortIcon('created')"></span></th>
                  <th class="location"><a (click)="sortTable('Customer.Name')">Customer</a> <span [innerHTML]="getSortIcon('customerName')"></span></th>
                  <th class="arrived"><a (click)="sortTable('Title')">Title</a> <span [innerHTML]="getSortIcon('title')"></span></th>
                  <th class="departed"><a (click)="sortTable('alertUrl')">Link</a> <span [innerHTML]="getSortIcon('alertUrl')"></span></th>
                  <th class="variance"><a (click)="sortTable('AcknowledgedBy.UserName')">Ack By</a> <span [innerHTML]="getSortIcon('acknowledgedBy')"></span></th>
                  <th class="variance"><a (click)="sortTable('ClosedBy.UserName')">Closed By</a> <span [innerHTML]="getSortIcon('closedBy')"></span></th>
                  <th class="variance"></th>
                  <th class="exp">
                    <button title="Export Data" class="export-button" >
                      <img class="export-image" alt="Export Data" src="../../img/btnExport.png" />
                    </button>
                  </th>
                </tr>
              </thead>
              <tbody class="dummy">
                <tr>
                  <td class="h-2" colspan="11"></td>
                </tr>
              </tbody>
              <tbody>
                @for (alert of alerts; track alert) {
                  <tr>
                    <td>
                      <input type="checkbox" name="alertcb[]" value="{{ alert.id }}" [checked]="alert.state" (change)="alert.state = !alert.state" />
                    </td>
                    <td [ngClass]="alert.priorityClass"></td>
                    <td class="vehicle"><div>{{ alert.alertDescription }}</div></td>
                    <td class="vehicle"><div>{{ alert.created | date:'dd/MM/yyyy HH:mm' }}</div></td>
                    <td class="location"><div>{{ alert.customerName }}</div></td>
                    <td class="location" [title]="alert.details" (click)="showDetails(alert)"><div>{{ alert.title }}</div></td>
                    <td class="location">
                      <div>
                        @if (alert.alertUrl != '') {
                          <a [href]="alert.alertUrl" target="_blank">Investigate</a>
                        }
                      </div>
                    </td>
                    <td class="location"><div>{{ alert.acknowledgedBy }}</div></td>
                    <td class="location"><div>{{ alert.closedBy }}</div></td>
                    <td class="location">
                      <div>
                        @if (alert.acknowledgedBy == '') {
                          <button class="btn btn-primary m-1" (click)="acknowledge(alert.id)">Acknowledge</button>
                        }
                        @if (alert.acknowledgedBy != '' && alert.closedBy != '') {
                          <button class="btn btn-primary m-1" (click)="close(alert.id)">On-Hold</button>
                        }
                        @if (alert.acknowledgedBy != '' && alert.closedBy == '') {
                          <button class="btn btn-primary m-1" (click)="close(alert.id)">Close</button>
                        }
                        @if (alert.actionUrl && alert.actionDescription && !alert.closedBy) {
                          <button class="btn btn-primary m-1" (click)="actionClose(alert)">{{ alert.actionDescription }}</button>
                        }
                      </div>
                    </td>
                    <td></td>
                  </tr>
                }
              </tbody>
            </table>
            <app-paging [paging]="paging" [pageChangeFunction]="changePage" [parentComponent]="this" showPageLabel="true"></app-paging>
          </div>
        </div>
      </div>
    </div>
